import React from 'react';
import RoutesConfig  from "./routes/routsConfig"



function App() {
  return (
    <RoutesConfig />
  );
}
export default App;

